/**
 * Colección: filtros, ordenación y "Cargar más" sin recargar la página.
 * Sin JavaScript el formulario sigue funcionando con una recarga normal.
 */
(() => {
  'use strict';

  if (customElements.get('facets-form')) return;

  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');

  class FacetsForm extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.sectionId = this.dataset.section;
      this.form = this.querySelector('form.facets');

      this.addEventListener('change', (event) => {
        if (this.form && event.target.form === this.form) this.submit();
      });

      this.addEventListener('submit', (event) => {
        if (event.target !== this.form) return;
        event.preventDefault();
        this.submit();
      });

      this.addEventListener('click', (event) => {
        const filterLink = event.target.closest('[data-facet-link]');
        if (filterLink) {
          event.preventDefault();
          this.load(new URL(filterLink.href, window.location.origin).search.slice(1), { push: true, replaceAll: true });
          return;
        }
        const more = event.target.closest('[data-load-more]');
        if (more) {
          event.preventDefault();
          this.loadMore(more);
        }
      });

      this.onPopState = () => this.load(window.location.search.slice(1), { push: false, replaceAll: true });
      window.addEventListener('popstate', this.onPopState);
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.onPopState);
    }

    submit() {
      const params = new URLSearchParams();
      new FormData(this.form).forEach((value, key) => {
        if (value !== '') params.append(key, value);
      });
      this.load(params.toString(), { push: true, replaceAll: false });
    }

    async load(query, { push, replaceAll }) {
      const path = window.location.pathname;
      const pageUrl = query ? `${path}?${query}` : path;
      const fetchUrl = `${path}?${query ? `${query}&` : ''}section_id=${this.sectionId}`;

      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.classList.add('is-loading');

      try {
        const response = await fetch(fetchUrl, { signal: this.controller.signal });
        if (!response.ok) throw new Error(String(response.status));
        const doc = parseHTML(await response.text());
        const active = document.activeElement;
        const activeId = active ? active.id : '';

        this.querySelectorAll('[data-region]').forEach((region) => {
          // No se toca el campo de precio mientras se está escribiendo en él
          if (!replaceAll && active && active.type === 'number' && region.contains(active)) return;
          const fresh = [...doc.querySelectorAll('[data-region]')].find(
            (item) => item.dataset.region === region.dataset.region
          );
          if (fresh) region.innerHTML = fresh.innerHTML;
        });

        // La ordenación puede cambiar al navegar con atrás/adelante
        const sort = this.querySelector('select[name="sort_by"]');
        const freshSort = doc.querySelector('select[name="sort_by"]');
        if (sort && freshSort) sort.value = freshSort.value;

        if (activeId && !document.contains(active)) {
          const again = document.getElementById(activeId);
          if (again) again.focus({ preventScroll: true });
        }
        if (push) window.history.pushState({}, '', pageUrl);
        this.classList.remove('is-loading');
      } catch (error) {
        if (error.name === 'AbortError') return;
        window.location.href = pageUrl;
      }
    }

    async loadMore(link) {
      if (link.classList.contains('is-loading')) return;
      const results = link.closest('[data-region="results"]');
      const grid = results ? results.querySelector('[data-product-grid]') : null;
      const pagination = results ? results.querySelector('[data-pagination]') : null;
      if (!grid || !pagination) {
        window.location.href = link.href;
        return;
      }
      link.classList.add('is-loading');
      link.setAttribute('aria-busy', 'true');
      try {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('section_id', this.sectionId);
        const response = await fetch(url);
        if (!response.ok) throw new Error(String(response.status));
        const doc = parseHTML(await response.text());
        const freshGrid = doc.querySelector('[data-product-grid]');
        const freshPagination = doc.querySelector('[data-pagination]');
        if (!freshGrid) throw new Error('empty');
        const firstNew = freshGrid.firstElementChild;
        grid.append(...freshGrid.children);
        pagination.innerHTML = freshPagination ? freshPagination.innerHTML : '';
        const focusTarget = firstNew ? firstNew.querySelector('.product-card__title a') : null;
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      } catch (error) {
        window.location.href = link.href;
      }
    }
  }
  customElements.define('facets-form', FacetsForm);
})();
